export const dev = {
  host: 'dev.ma-navigator.com',
  imageFluxHost: 'p1-5ad5435b.imageflux.jp',
  gtmId: 'GTM-W7SJQFL',
  ENABLE_MICROCMS: false,
  ENABLE_NEWT: true,
}
